export const COMMITTEE_ACTIONS = {
  SET_COMMITTEES: 'SET_COMMITTEES',
  SET_COMMITTEES_IS_LOADING: 'SET_COMMITTEES_IS_LOADING',
  SET_CURRENT_COMMITTEE: 'SET_CURRENT_COMMITTEE',
  SET_CURRENT_COMMITTEE_IS_LOADING: 'SET_CURRENT_COMMITTEE_IS_LOADING',
};